import { ComponentDocs } from "components/docs";
import { ComponentExample } from "components/examples";

const SignalR = () => (
  <ComponentDocs name="<SignalR/>" entry="SignalR" propsEntry="SignalRProps">
    <ComponentExample
      name="Hub Events"
      rawImport={import("examples/SignalR/SignalR/HubEventsExample?raw")}
    />
    <ComponentExample
      name="Hub Group / Channel Subscription"
      rawImport={import("examples/SignalR/SignalR/HubSubscriptionExample?raw")}
    />
  </ComponentDocs>
);

export default SignalR;
